import React from "react";
import LoginComponent  from "../../components/LoginComponent";



export const Login = () => {
    return (
        <LoginComponent />
    );
}